import React from 'react';
import Wholesalepage from '../../../../../components/page/wholesale/Wholesalepage';

export default function WholesaleVendor() {
	return (
		<>
			<Wholesalepage />
		</>
	);
}
